import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  spotConstants,
  translationConstants,
  CenterSpotStatusEnum,
  GoogleMapConstants,
  Directions,
} from "../../../../../../../constants";
import GoogleMapView from "../../../../../../../shared/components/GoogleMap/GoogleMapView";
import InfiniteScroll from "react-infinite-scroll-component";
import LocationSpotAttributeWrapper from "../../../../../../../shared/components/CenterLocationSpot/LocationSpotAttributeWrapper";
import { dataEndMessage, loadingIndicator } from "../../../../../../../shared/utilitiies";

const LocationsTab = (props) => {
  const { t } = useTranslation();
  //-------Destructure Props
  const { centerProfileData } = props;
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );
  //-------UseState
  const [mapCenter, setMapCenter] = useState({
    lat: GoogleMapConstants.DEFAULT_LATITUDE,
    lng: GoogleMapConstants.DEFAULT_LONGITUDE,
  });
  const [locations, setLocations] = useState([]);

  //-------Map Style
  const MapContainerStyle = {
    width: "100%",
    height: "35vh",
    borderRadius: ".5em",
  };
  //-------Map options
  const options = {
    zoomControl: true,
    clickableIcons: false,
    disableDefaultUI: true,
  };
  useEffect(() => {
    const transformedData = centerProfileData?.centerSpots
      .filter((spot) => spot.status === CenterSpotStatusEnum.Approved) // Filter spots with status Approved
      .map((spot) => ({
        latitude: parseFloat(spot.lat),
        longitude: parseFloat(spot.long),
        locationName: spot?.spotName,
        locationArabicName: spot?.spotArabicName,
        spotTypeId: spot.spotTypeId,
        sports: spot.sportIds,
        isPublic: spot.spotTypeId,
      }));
    setLocations(transformedData);
    // eslint-disable-next-line
  }, [centerProfileData]);

  return (
    <div className="row m-0 px-1">
      <div className="col-12 mb-2">
        <GoogleMapView
          containerStyle={MapContainerStyle}
          options={options}
          mapCenter={mapCenter}
          locations={locations}
        />
      </div>
      <section className="mt-5 mb-5">
        <InfiniteScroll
          dataLength={centerProfileData?.centerSpots?.length ?? 0}
          hasMore={
            centerProfileData?.centerSpots?.length % 10 === 0 &&
            centerProfileData?.centerSpots?.length !== 0
          }
          loader={loadingIndicator(t)}
          endMessage={dataEndMessage(t , centerProfileData?.centerSpots)}
          style={{ overflow: "hidden" }}
          scrollableTarget={"main-container"}
        >
          {centerProfileData?.centerSpots?.map((spot) => (
            <LocationSpotAttributeWrapper
              key={spot.id}
              spotData={spot}
            />
          ))}
        </InfiniteScroll>
      </section>
    </div>
  );
};

export default LocationsTab;
